// frontend/src/pages/admin/ManageNotificationsPage.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaPaperPlane, FaBell, FaCheckDouble, FaRegEnvelope, FaTrash, FaEyeSlash } from 'react-icons/fa';

const ManageNotificationsPage = () => {
    const [users, setUsers] = useState([]);
    const [sentNotifications, setSentNotifications] = useState([]); 
    const [selectedUser, setSelectedUser] = useState('all');
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [msg, setMsg] = useState(null);

    const API_URL = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api';
    const getCleanToken = () => localStorage.getItem('token')?.replace(/"/g, '');

    const fetchData = async () => {
        const token = getCleanToken();
        const config = { headers: { Authorization: `Bearer ${token}` } };
        
        try {
            const [usersRes, notifRes] = await Promise.all([
                axios.get(`${API_URL}/users`, config),
                axios.get(`${API_URL}/extras/notifications/all`, config) 
            ]);

            setUsers(usersRes.data);
            setSentNotifications(notifRes.data);
        } catch (error) { console.error(error); }
    };

    useEffect(() => { fetchData(); }, []);

    const handleSend = async (e) => {
        e.preventDefault();
        const token = getCleanToken();
        try {
            await axios.post(`${API_URL}/extras/notifications`, 
                { userId: selectedUser, title, message }, 
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setMsg({ type: 'success', text: 'Bildirim gönderildi.' });
            setTitle(''); setMessage('');
            fetchData(); 
        } catch (error) { setMsg({ type: 'error', text: 'Gönderilemedi.' }); }
    };

    // Admin Silme (Hard Delete)
    const handleDelete = async (id) => {
        if(!window.confirm("Bu bildirimi kalıcı olarak silmek istiyor musunuz?")) return;
        const token = getCleanToken();
        try {
            await axios.post(`${API_URL}/extras/notifications/${id}?_method=DELETE`, {}, { headers: { Authorization: `Bearer ${token}` } });
            fetchData();
        } catch(error) { alert('Silinemedi'); }
    };

    return (
        <div className="space-y-8 max-w-5xl mx-auto pb-10">
            {/* GÖNDERME FORMU */}
            <div className="bg-surface p-6 rounded-xl border border-border shadow-lg">
                <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2"><FaPaperPlane className="text-primary"/> Yeni Bildirim Gönder</h2>
                
                {msg && <div className={`p-3 rounded border mb-4 ${msg.type === 'success' ? 'bg-green-900 border-green-500 text-green-300' : 'bg-red-900 border-red-500 text-red-300'}`}>{msg.text}</div>}

                <form onSubmit={handleSend} className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-xs font-bold text-text-secondary mb-1">Kime?</label>
                            <select value={selectedUser} onChange={e => setSelectedUser(e.target.value)} className="w-full bg-background border border-border rounded p-2 text-white outline-none focus:border-primary">
                                <option value="all">📢 TÜM ÜYELERE GÖNDER</option>
                                {users.map(u => <option key={u._id} value={u._id}>{u.name}</option>)}
                            </select>
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-text-secondary mb-1">Başlık</label>
                            <input type="text" value={title} onChange={e => setTitle(e.target.value)} className="w-full bg-background border border-border rounded p-2 text-white outline-none focus:border-primary" required />
                        </div>
                    </div>
                    <div>
                        <label className="block text-xs font-bold text-text-secondary mb-1">Mesaj</label>
                        <textarea value={message} onChange={e => setMessage(e.target.value)} className="w-full bg-background border border-border rounded p-2 text-white outline-none h-20" required></textarea>
                    </div>
                    <button type="submit" className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white py-2 rounded-lg font-bold transition-all shadow-md">GÖNDER</button>
                </form>
            </div>

            {/* GİDEN KUTUSU (LİSTE) */}
            <div>
                <h2 className="text-xl font-bold text-white mb-4">Son Gönderilenler</h2>
                <div className="bg-surface border border-border rounded-xl overflow-hidden shadow-lg">
                    <div className="overflow-x-auto">
                        <table className="w-full text-left text-sm text-text-secondary">
                            <thead className="bg-gray-800 text-white uppercase font-bold text-xs">
                                <tr>
                                    <th className="p-4">Tarih</th>
                                    <th className="p-4">Alıcı</th>
                                    <th className="p-4">Başlık & Mesaj</th>
                                    <th className="p-4 text-center">Durum</th>
                                    <th className="p-4 text-center">İşlem</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-border">
                                {sentNotifications.map(notif => (
                                    <tr key={notif._id} className="hover:bg-gray-800/50 transition-colors">
                                        <td className="p-4 font-mono text-xs text-gray-400">{new Date(notif.createdAt).toLocaleString('tr-TR')}</td>
                                        <td className="p-4 font-bold text-primary">
                                            {notif.userId ? (notif.userId.name || 'Özel') : 'Genel Duyuru'}
                                        </td>
                                        <td className="p-4">
                                            <p className="text-white font-bold text-sm">{notif.title}</p>
                                            <p className="text-xs truncate max-w-xs text-gray-400">{notif.message}</p>
                                        </td>
                                        <td className="p-4 text-center">
                                            <div className="flex flex-col items-center gap-1">
                                                {notif.isRead ? (
                                                    <span className="text-green-400 flex items-center gap-1 text-[10px] font-bold"><FaCheckDouble /> OKUNDU</span>
                                                ) : (
                                                    <span className="text-yellow-500 flex items-center gap-1 text-[10px] font-bold"><FaRegEnvelope /> İLETİLDİ</span>
                                                )}
                                                
                                                {/* Kullanıcı Sildi mi? */}
                                                {notif.isDeletedByUser && (
                                                    <span className="text-red-400 flex items-center gap-1 text-[9px] font-bold border border-red-500/30 px-1 rounded bg-red-500/10">
                                                        <FaEyeSlash /> KULLANICI SİLDİ
                                                    </span>
                                                )}
                                            </div>
                                        </td>
                                        <td className="p-4 text-center">
                                            <button onClick={() => handleDelete(notif._id)} className="text-red-500 hover:text-white hover:bg-red-600 p-2 rounded transition-colors">
                                                <FaTrash />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {sentNotifications.length === 0 && <div className="p-8 text-center text-gray-500">Henüz bildirim gönderilmemiş.</div>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManageNotificationsPage;